import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Shell } from "@/components/Shell";
import AskPage from "@/pages/AskPage";
import PartnersPage from "@/pages/PartnersPage";
import ReallocationPage from "@/pages/ReallocationPage";
import BenchmarkPage from "@/pages/BenchmarkPage";
import NeedFundingPage from "@/pages/NeedFundingPage";
import BriefPage from "@/pages/BriefPage";
import DatasetsPage from "@/pages/DatasetsPage";
import ContextPage from "@/pages/ContextPage";
import DataRealityPage from "@/pages/DataRealityPage";
import AuditPage from "@/pages/AuditPage";
import DataTrustPage from "@/pages/DataTrustPage";
import BoardNotePage from "@/pages/BoardNotePage";
import "@/App.css";

export default function App() {
  return (
    <BrowserRouter>
      <Shell>
        <Routes>
          <Route path="/" element={<AskPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/reallocation" element={<ReallocationPage />} />
          <Route path="/benchmark" element={<BenchmarkPage />} />
          <Route path="/need-funding" element={<NeedFundingPage />} />
          <Route path="/brief" element={<BriefPage />} />
          <Route path="/board-note" element={<BoardNotePage />} />
          <Route path="/data-trust" element={<DataTrustPage />} />
          <Route path="/datasets" element={<DatasetsPage />} />
          <Route path="/context" element={<ContextPage />} />
          <Route path="/data-reality" element={<DataRealityPage />} />
          <Route path="/audit" element={<AuditPage />} />
        </Routes>
      </Shell>
    </BrowserRouter>
  );
}
